'use client';

export { PediatricsForm } from '@/components/forms/PediatricsForm';
